import React from 'react';

import { Grid, SegmentedControl } from '@cowbell/ui';

import classes from './OrgSubsidiaryRow.module.css';

/** The `{ value, label }` pair the form stores for this question. */
export type FranchiseValue = { value: any; label: React.ReactNode } | null;

interface OrgSubsidiaryRowProps {
  readonly legend: string;
  readonly value: FranchiseValue;
  readonly onChange: (value: boolean) => void;
}

/**
 * The subsidiary/franchise question, as the design's own row: a legend and a
 * line of explanation on the left, a Yes/No segmented control hard right.
 *
 * <p>The design draws this as a segmented pill rather than a pair of radios,
 * which is what the accordion used. The form value it writes keeps the
 * `{ value, label }` shape the submit handler unwraps.
 */
export const OrgSubsidiaryRow = ({
  legend,
  value,
  onChange,
}: OrgSubsidiaryRowProps) => {
  const selected = value?.value === true ? 'yes' : 'no';

  return (
    <Grid.Col span={12}>
      <div className={classes.row}>
        <div>
          <p className={classes.legend}>{legend}</p>
          <p className={classes.description}>
            We use this to link your policy to a parent organization.
          </p>
        </div>
        <SegmentedControl
          className={classes.control}
          color="blue"
          withItemsBorders={false}
          value={selected}
          onChange={(next) => onChange(next === 'yes')}
          data={[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ]}
          aria-label={legend}
        />
      </div>
    </Grid.Col>
  );
};

export default OrgSubsidiaryRow;
